import React, { useState, useRef } from 'react';
import { supabase } from '../supabase';
import { Autocomplete } from '@react-google-maps/api';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
registerLocale('es', es);

function FormularioTrabajo({ secciones, onCerrar, onGuardado, session }) {
  const [form, setForm] = useState({
    titulo: '', tipo: 'mantenimiento', seccion: '',
    descripcion: '', estado: 'pendiente', autor: '',
    latitud: '', longitud: '',
    codigo_informe: '', numero_trabajo: '', lugar: '',
    hora_inicio: '', hora_fin: '', kilometros: '',
    desarrollo: ''
  });
  const [fecha, setFecha] = useState(null);
  const [fechaInicio, setFechaInicio] = useState(null);
  const [fechaFin, setFechaFin] = useState(null);
  const autocompleteRef = useRef(null);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const formatFecha = (date) => {
    if (!date) return null;
    return date.toISOString().split('T')[0];
  };

  const onPlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();
    if (place.geometry) {
      setForm({
        ...form,
        latitud: place.geometry.location.lat(),
        longitud: place.geometry.location.lng()
      });
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();

    let seccionId = null;
    const existente = secciones.find(s => s.nombre.toLowerCase() === form.seccion.toLowerCase());
    if (existente) {
      seccionId = existente.id;
    } else {
      const { data } = await supabase.from('secciones').insert([{ nombre: form.seccion }]).select();
      if (data) seccionId = data[0].id;
    }

    const { error } = await supabase.from('trabajos').insert([{
      titulo: form.titulo,
      tipo: form.tipo,
      seccion_id: seccionId,
      descripcion: form.descripcion,
      fecha: formatFecha(fecha),
      fecha_inicio: formatFecha(fechaInicio),
      fecha_fin: formatFecha(fechaFin),
      estado: form.estado,
      autor: form.autor,
      latitud: parseFloat(form.latitud),
      longitud: parseFloat(form.longitud),
      user_id: session?.user?.id,
      codigo_informe: form.codigo_informe,
      numero_trabajo: form.numero_trabajo,
      lugar: form.lugar,
      hora_inicio: form.hora_inicio,
      hora_fin: form.hora_fin,
      kilometros: form.kilometros,
      desarrollo: form.desarrollo,
    }]);

    if (!error) onGuardado();
    else alert('Error al guardar: ' + error.message);
  };

  const datepickerStyle = {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '0.95rem',
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Agregar Trabajo</h2>
        <form onSubmit={handleSubmit}>

          <div className="form-seccion-titulo">📋 Datos generales</div>
          <input name="titulo" placeholder="Título del trabajo" onChange={handleChange} required />
          <input name="numero_trabajo" placeholder="Número de trabajo (ej: Tr.1)" onChange={handleChange} />
          <input name="codigo_informe" placeholder="Código de informe (ej: BP-TGN-MANT.PACHECO-4.26-Rev0)" onChange={handleChange} />

          <select name="tipo" onChange={handleChange}>
            <option value="mantenimiento">Mantenimiento</option>
            <option value="reparacion">Reparación</option>
            <option value="inspeccion">Inspección</option>
            <option value="instalacion">Instalación</option>
          </select>

          <select name="estado" onChange={handleChange}>
            <option value="pendiente">Pendiente</option>
            <option value="en progreso">En progreso</option>
            <option value="finalizado">Finalizado</option>
          </select>

          <input name="seccion" placeholder="Provincia" onChange={handleChange} required />
          <input name="autor" placeholder="Encargado" onChange={handleChange} />
          <input name="lugar" placeholder="Lugar (ej: Villa Madero)" onChange={handleChange} />

          <div className="form-seccion-titulo">📅 Fechas y horarios</div>
          <label>Fecha del trabajo</label>
          <DatePicker
            selected={fecha}
            onChange={setFecha}
            locale="es"
            dateFormat="dd/MM/yyyy"
            placeholderText="Seleccioná una fecha"
            customInput={<input style={datepickerStyle} />}
          />
          <label>Fecha inicio</label>
          <DatePicker
            selected={fechaInicio}
            onChange={setFechaInicio}
            locale="es"
            dateFormat="dd/MM/yyyy"
            placeholderText="Seleccioná fecha de inicio"
            customInput={<input style={datepickerStyle} />}
          />
          <label>Fecha fin</label>
          <DatePicker
            selected={fechaFin}
            onChange={setFechaFin}
            locale="es"
            dateFormat="dd/MM/yyyy"
            placeholderText="Seleccioná fecha de fin"
            customInput={<input style={datepickerStyle} />}
          />

          <div className="coords-row">
            <input name="hora_inicio" placeholder="Hora inicio (ej: 07:37)" onChange={handleChange} />
            <input name="hora_fin" placeholder="Hora fin (ej: 18:23)" onChange={handleChange} />
          </div>
          <input name="kilometros" placeholder="Kilómetros recorridos (ej: 152)" onChange={handleChange} />

          <div className="form-seccion-titulo">📝 Descripción</div>
          <textarea name="descripcion" placeholder="Descripción breve del trabajo" onChange={handleChange} />
          <textarea
            name="desarrollo"
            placeholder="Desarrollo / Resultados (texto completo del informe)"
            onChange={handleChange}
            style={{ height: '120px' }}
          />

          <div className="form-seccion-titulo">📍 Ubicación</div>
          <Autocomplete
            onLoad={ref => autocompleteRef.current = ref}
            onPlaceChanged={onPlaceChanged}
          >
            <input placeholder="Buscar dirección en Google Maps..." style={datepickerStyle} />
          </Autocomplete>

          <div className="coords-row">
            <input name="latitud" placeholder="Latitud" value={form.latitud} onChange={handleChange} required />
            <input name="longitud" placeholder="Longitud" value={form.longitud} onChange={handleChange} required />
          </div>

          <div className="modal-botones">
            <button type="button" onClick={onCerrar}>Cancelar</button>
            <button type="submit">Guardar</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FormularioTrabajo;